import { CashbackAccountAdapter as t } from "../../../../customer/cashback/cashbackAccount/cashbackAccount.adapter.js";
import { CashbackConfigurationAdapter as r } from "../../../../customer/cashback/cashbackConfiguration/cashbackConfiguration.adapter.js";
import { Adapter as e, getAdapter as o } from "../../../../../adapter.js";
import { ShopSessionCashbackModel as p } from "./shopSessionCashback.model.js";
class m extends e {
  adapt(a) {
    return new p({
      configuration: o(r).adapt(a),
      account: o(t).adapt(a.account)
    });
  }
  serialize(a) {
  }
}
export {
  m as ShopSessionCashbackAdapter
};
//# sourceMappingURL=shopSessionCashback.adapter.js.map
